import { Box, Typography, Button, Grid2 as Grid } from '@mui/material';
import React from 'react';
import { TypographyTitleStyled, TypographyStyled } from './style';
import { controlPadData } from '../../shared/shared.constants';
import { ControlPad } from '../../shared/components/controlPad';
import { BoxStyled } from '../estimatingRequirements/faisyEquation/style';
import tcPDF from '../../assets/pdf/Abbott_Nutritional_App_Terms_Conditions_Ireland_PWA.pdf';
import infoIcon from '../../assets/icons/infoLargeIcon.svg';
import downloadIcon from '../../assets/icons/downloadIcon.svg';

export const TermsAndConditions = () => {
  const openPDF = () => {
    window.open(tcPDF, '_blank');
  };

  return (
    <>
      <BoxStyled sx={{ paddingBottom: '0px' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            gap: '1.875rem',
            marginTop: '3.125rem'
          }}
        >
          <Box
            sx={{
              width: '110px',
              height: '110px',
              borderRadius: '100px',
              backgroundColor: '#fff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img src={infoIcon} alt="infoIcon" />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              sx={{
                fontSize: '1.5625rem',
                lineHeight: '35px',
                fontFamily: 'BGBold',
                fontWeight: '450',
                textTransform: 'uppercase'
              }}
            >
              Application Terms and Conditions of Use
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              gap: '1.25rem'
            }}
          >
            <Button
              variant="contained"
              onClick={openPDF}
              data-testid="downloadIcon"
              endIcon={<img src={downloadIcon} alt="downloadIcon" />}
              sx={{
                borderRadius: '1.25rem',
                height: '3.125rem',
                background: '#007acc'
              }}
            >
              DOWNLOAD
            </Button>
          </Box>
          <Box
            sx={{
              width: '95%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'left',
              flexDirection: 'column',
              gap: '1.25rem'
            }}
          >
            <ol
              style={{
                display: 'flex',
                gap: '0.75rem',
                flexDirection: 'column'
              }}
            >
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>Who We Are</TypographyTitleStyled>
              </li>
              <TypographyStyled>
                Abbott Laboratories Limited can be found at its registered
                office address at Abbott Nutrition, Block B, Liffey Valley
                Office Campus, Quarryvale, Dublin 22, D22 XOY3 with company
                registration number 11542 (“
                <span style={{ fontFamily: 'CalibriBold' }}>Abbott</span>”).
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Use of the Application
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      2.1
                    </span>{' '}
                    These Terms and Conditions (the “
                    <span style={{ fontFamily: 'CalibriBold' }}>
                      Terms and Conditions
                    </span>
                    ”) apply to the use of the Abbott Nutrition App (“
                    <span style={{ fontFamily: 'CalibriBold' }}>
                      Application”
                    </span>
                    ). The Application is owned by Abbott and its licensors.
                    This Application is for use by qualified healthcare
                    professionals in the Republic of Ireland only. Persons who
                    are not fully trained and qualified healthcare professionals
                    in the Republic of Ireland should not download, access or
                    use the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      2.2
                    </span>{' '}
                    By clicking the Agree button below you agree and confirm
                    that (i) you are a qualified healthcare professional in
                    theRepublic of Ireland , (ii) you practice your profession
                    in the Republic of Ireland, and (iii) you are about to
                    download the Application in the Republic of Ireland. In
                    accessing this Application you will act in compliance with
                    these Terms and Conditions and all applicable laws, rules,
                    codes and regulations.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      2.3
                    </span>{' '}
                    By installing or using the Application, you agree to be
                    bound by these Terms and Conditions (and any amendments).
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Access to the Application
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      3.1
                    </span>{' '}
                    Your access to the Application is subject to these Terms and
                    Conditions which may be updated or amended from time to time
                    without notice to users. Abbott reserves the right to
                    terminate access in whole or in part to the Application at
                    any time and for any reason without prior notification to
                    you.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      3.2
                    </span>{' '}
                    By accessing or using the Application, you are agreeing that
                    you have read, understood and agree to be bound to these
                    Terms and Conditions (and any amendments). Users are
                    responsible for periodically reviewing these Terms and
                    Conditions for amendments. Use of the Application after any
                    amendment to these Terms and Conditions constitutes your
                    acceptance to any such amendments. If you disagree with
                    these Terms and Conditions (as they may be amended from time
                    to time) or are dissatisfied with the Application, your sole
                    and exclusive remedy is to discontinue use of this
                    Application.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Ownership of the Application
                </TypographyTitleStyled>
              </li>
              <TypographyStyled>
                The Application is owned by Abbott. The registered office
                address of Abbott Laboratories Limited is Abbott Nutrition,
                Block B, Liffey Valley Office Campus, Quarryvale, Dublin 22, D22
                XOY3 and the company registration number is 11542.
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>Data Charges</TypographyTitleStyled>
              </li>
              <TypographyStyled>
                Neither Abbott nor its licensors shall have any liability in
                respect of data charges that individuals may incur in accessing
                the Application or the Abbott website at
                <a href="www.abbottnutrition.ie" style={{ color: '#002A3A' }}>
                  {' '}
                  www.abbottnutrition.ie
                </a>{' '}
                The user of the Application shall have sole responsibility for
                the payment of all such charges howsoever incurred.
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  System Requirements and Availability
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      6.1
                    </span>{' '}
                    In order to use the Application, the user using the
                    Application must have a compatible mobile phone or device,
                    with an internet connection and that meets the minimum
                    specifications.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      6.2
                    </span>{' '}
                    The Application software version may undergo periodic
                    updates to add support for new features and services.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      6.3
                    </span>{' '}
                    The software requirements are as follows: Android devices
                    with Android 4.3 and higher operating systems; Requires iOS
                    12.0 or higher.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Scope of Terms and Conditions
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      7.1
                    </span>{' '}
                    These Terms and Conditions apply to the use of the
                    Application only.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      7.2
                    </span>{' '}
                    In order to access some of the functionality of this
                    Application, the user will be transferred to the Abbott
                    Nutrition Ireland website at www.abbottnutrition.ie. The use
                    of{' '}
                    <a
                      href="www.abbottnutrition.ie"
                      style={{ color: '#002A3A' }}
                    >
                      {' '}
                      www.abbottnutrition.ie
                    </a>{' '}
                    is subject to Abbott’s Online Terms and Conditions, which
                    can be viewed at
                    <a
                      href="www.abbottnutrition.ie/terms"
                      style={{ color: '#002A3A' }}
                    >
                      https://www.abbottnutrition.ie/terms.
                    </a>
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      7.3
                    </span>{' '}
                    Any personal information that you supply to Abbott when
                    using the Application will be used by Abbott in accordance
                    with its Privacy Policy, which can be viewed at
                    <a
                      href="www.abbottnutrition.ie/privacy"
                      style={{ color: '#002A3A' }}
                    >
                      {' '}
                      www.abbottnutrition.ie/privacy
                    </a>
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Responsibility of Healthcare Professionals
                </TypographyTitleStyled>
              </li>
              <TypographyStyled>
                The healthcare professional who is a user of the Application
                recognises and accepts that the use of the contents and/or
                services offered by the Application will be at its sole risk
                and/or responsibility. The healthcare professional agrees to use
                the Application and all its content and services in accordance
                with the law, ethical codes and these Terms and Conditions. The
                healthcare professional undertakes to make appropriate use of
                the services and/or contents of the Application and not to use
                them to carry out illicit activities or activities that
                constitute a crime, that violate the rights of third parties
                and/or that infringe the regulations on intellectual and
                industrial property, or any other applicable regulation. In
                particular, the healthcare professional user of the application
                agrees not to transmit, introduce, disseminate or make available
                to third parties, any type of material and information
                (contained data, messages, drawings, sound and image files,
                photographs, software, etc.) that are contrary to the law,
                ethical codes and these Terms and Conditions.
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Estimation of Requirements Tool
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      9.1
                    </span>{' '}
                    The Estimation of Requirements Tool is developed with the
                    kind permissions of the parties referenced through the Tool.
                    Users of the Application are entitled to use the Estimation
                    of Requirements Tool solely while carrying out their
                    professional duties and are strictly prohibited from
                    reproducing the Estimation of Requirements Tool in all forms
                    whatsoever. Abbott does not make any representation or
                    warranty with respect to the completeness of the Estimation
                    of Requirements Tool and strictly disclaims all
                    representations and warranties relating to the information,
                    content and outcomes generated by the Estimation of
                    Requirements Tool, whether expressed or implied, created by
                    law, contract or otherwise. The information generated
                    through use of the Estimation of Requirements Tool is
                    indicative only and should not be construed as medical
                    advice or diagnosis, all results generated through the use
                    of the Estimation of Requirements Tool should be verified
                    using clinical skill and judgement and other methods.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      9.2
                    </span>{' '}
                    Abbott excludes all liability associated with the use of the
                    Estimation of Requirements Tool in any particular
                    circumstances. Healthcare professionals are strongly advised
                    to use clinical skill and judgement in the use of the
                    Estimation of Requirements Tool and should not rely on the
                    results generated by the Estimation of Requirements Tool for
                    the purposes of treatment.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      9.3
                    </span>{' '}
                    Abbott hereby disclaims all liability for any loss or damage
                    which may be suffered by any person, whether suffered
                    directly, indirectly, immediately or consequentially, and
                    whether arising in contract, tort (including negligence) or
                    otherwise which arises out of, or in connection with use of
                    the Estimation of Requirements Tool and any treatment or
                    care decisions made by the user of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      9.4
                    </span>{' '}
                    The inclusion of calculation methodology within the
                    Estimation of Requirements Tool should not be deemed to
                    constitute endorsement by any of the referenced copyright
                    holders of Abbott or any Abbott products.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>MUST Calculator</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      10.1
                    </span>{' '}
                    The Malnutrition Universal Screening Tool (‘MUST’) is
                    reproduced with permission from the British Association for
                    Parenteral & Enteral Nutrition (“
                    <span style={{ fontFamily: 'CalibriBold' }}>BAPEN</span>”).
                    Abbott shall not make any representation or warranty with
                    respect to the completeness of the ‘MUST’ and Abbott
                    strictly disclaims all representations and warranties
                    relating to the information and content of the ‘MUST’,
                    whether expressed or implied, created by law, contract or
                    otherwise.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      10.2
                    </span>{' '}
                    Abbott excludes all liability associated with the use of
                    ‘MUST’ in any particular circumstances. Healthcare
                    professionals are strongly advised to use clinical skill and
                    judgement in the use of ‘MUST’ and any results generated
                    through use of ‘MUST’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      10.3
                    </span>{' '}
                    Abbott hereby disclaims all liability for any loss or damage
                    which may be suffered by any person, whether suffered
                    directly, indirectly, immediately or consequentially, and
                    whether arising in contract, tort (including negligence) or
                    otherwise which arises out of, or in connection with use of
                    ‘MUST’ and any treatment or care decisions made by the user
                    of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      10.4
                    </span>{' '}
                    Abbott does make any representation or warranty that the
                    ‘MUST’ used in the Application is the most current or up to
                    date version of the ‘MUST’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      10.5
                    </span>{' '}
                    The inclusion of ‘MUST’ as part of the Application does not
                    constitute any endorsement by BAPEN of Abbott or any Abbott
                    products.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      10.6
                    </span>{' '}
                    For more information about ‘MUST’ and BAPEN users should
                    consult{' '}
                    <a href="www.bapen.org.uk" style={{ color: '#002A3A' }}>
                      {' '}
                      www.bapen.org.uk
                    </a>
                    .
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>GLIM Calculator</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      11.1
                    </span>{' '}
                    The Global Leadership on Malnutrition (GLIM) is reproduced
                    with permission from Tommy Cederholm. Abbott shall not make
                    any representation or warranty in respect to the
                    completeness of the ‘GLIM criteria’ and Abbott strictly
                    disclaims all representations and warranties relating to the
                    information and content of the ‘GLIM criteria’, whether
                    expressed or implied, created by law, contract or otherwise.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      11.2
                    </span>{' '}
                    Abbott excludes all liability associated with the use of
                    ‘GLIM criteria’ in any particular circumstances. Healthcare
                    professionals are strongly advised to use clinical skill and
                    judgement in the use of ‘GLIM criteria’ and any results
                    generated through use of ‘GLIM criteria’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      11.3
                    </span>{' '}
                    Abbott hereby disclaims all liability for any loss or damage
                    which may be suffered by any person, whether suffered
                    directly, indirectly, immediately or consequentially, and
                    whether arising in contract, tort (including negligence) or
                    otherwise which arises out of, or in connection with use of
                    ‘GLIM Criteria and any treatment or care decisions made by
                    the user of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      11.3
                    </span>{' '}
                    Abbott does make any representation or warranty that the
                    ‘GLIM Criteria’ used in the Application is the most current
                    or up to date version of the ‘GLIM Criteria’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      11.4
                    </span>{' '}
                    The inclusion of ‘GLIM Criteria as part of the Application
                    does not constitute any endorsement by Dr Tommy Cederholm
                    and colleagues of Abbott or any Abbott products
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    For more information about ‘GLIM Criteria’ users should
                    consult{' '}
                    <a
                      href="https://www.espen.org/files/GLIM_criteria.pdf"
                      style={{ color: '#002A3A' }}
                    >
                      {' '}
                      https://www.espen.org/files/GLIM_criteria.pdf
                    </a>
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>MST Calculator</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      12.1
                    </span>{' '}
                    The Malnutriton Screening Tool (MST) is reproduced with
                    permission from Dr Maree Ferguson and Elselvier. Abbott
                    shall not make any representation or warranty in respect to
                    the completeness of the ‘MST’ and Abbott strictly disclaims
                    all representations and warranties relating to the
                    information and content of the ‘MST’, whether expressed or
                    implied, created by law, contract or otherwise.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      12.2
                    </span>{' '}
                    Abbott excludes all liability associated with the use of
                    ‘MST’ in any particular circumstances. Healthcare
                    professionals are strongly advised to use clinical skill and
                    judgement in the use of ‘MST’ and any results generated
                    through use of ‘MST’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      12.3
                    </span>{' '}
                    Abbott hereby disclaims all liability for any loss or damage
                    which may be suffered by any person, whether suffered
                    directly, indirectly, immediately or consequentially, and
                    whether arising in contract, tort (including negligence) or
                    otherwise which arises out of, or in connection with use of
                    ‘MST’ and any treatment or care decisions made by the user
                    of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      12.4
                    </span>{' '}
                    Abbott does make any representation or warranty that the
                    ‘MST’ used in the Application is the most current or up to
                    date version of the ‘MST’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      12.5
                    </span>{' '}
                    The inclusion of ‘MST’ as part of the Application does not
                    constitute any endorsement by Dr Maree Ferguson of Abbott or
                    any Abbott products.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      12.6
                    </span>{' '}
                    For more information about ‘MST’ users should consult Dr
                    Maree Ferguson.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>SARC-F Tool</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.1
                    </span>{' '}
                    The SARC-F Tool is reproduced with permission from Dr TK
                    Malstrom and colleagues and Elselvier. Abbott shall not make
                    any representation or warranty in respect to the
                    completeness of the ‘SARC-F’ and Abbott strictly disclaims
                    all representations and warranties relating to the
                    information and content of the ‘SARC-F’, whether expressed
                    or implied, created by law, contract or otherwise.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.2
                    </span>{' '}
                    Abbott excludes all liability associated with the use of
                    ‘SARC-F’ in any particular circumstances. Healthcare
                    professionals are strongly advised to use clinical skill and
                    judgement in the use of ‘SARC-F‘ and any results generated
                    through use of ‘SARC-F’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.3
                    </span>{' '}
                    Abbott hereby disclaims all liability for any loss or damage
                    which may be suffered by any person, whether suffered
                    directly, indirectly, immediately or consequentially, and
                    whether arising in contract, tort (including negligence) or
                    otherwise which arises out of, or in connection with use of
                    ‘MST’ and any treatment or care decisions made by the user
                    of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.4
                    </span>{' '}
                    Abbott hereby disclaims all liability for any loss or damage
                    which may be suffered by any person, whether suffered
                    directly, indirectly, immediately or consequentially, and
                    whether arising in contract, tort (including negligence) or
                    otherwise which arises out of, or in connection with use of
                    ‘SARC-F’ and any treatment or care decisions made by the
                    user of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.5
                    </span>{' '}
                    Abbott does make any representation or warranty that the
                    ‘SARC-F’ used in the Application is the most current or up
                    to date version of the ‘SARC-F’.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.6
                    </span>{' '}
                    The inclusion of ‘SARC-F’ as part of the Application does
                    not constitute any endorsement by Dr TK Malstrom of Abbott
                    or any Abbott products.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      13.7
                    </span>{' '}
                    For more information about ‘SARC-F’ users should consult DR
                    TK Malstrom.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Complaints About Abbott Products
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      14.1
                    </span>{' '}
                    Should you wish to report a complaint about an Abbott
                    product please use the Contact Us function on the
                    Application in order to send Abbott an email.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      14.2
                    </span>{' '}
                    In the alternative, please call the Abbott Dietetic
                    Freephone Helpline 1800 411 411.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Direct-To-Patient Samples Service
                </TypographyTitleStyled>
              </li>
              <TypographyStyled>
                The user gets redirected to{' '}
                <a
                  href="anieuhcp.my.salesforce-sites.com/SamplesIE"
                  style={{ color: '#002A3A' }}
                >
                  anieuhcp.my.salesforce-sites.com/SamplesIE
                </a>
                , where samples can be ordered to be delivered within 1-2
                working days. The website lists Abbott products only. You should
                consider all treatments that may be available to patients, in
                accordance with clinical skill and practice.
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>Disclaimer</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.1
                    </span>{' '}
                    Abbott will take reasonable care to ensure that the
                    information and content on the Application is accurate,
                    complete, up to date, and always available and does not
                    infringe any third party rights. However, Abbott does not
                    guarantee that this is always the case. The Application and
                    the content and information on it are provided on an “as is”
                    and “as available” basis, with all faults. To the maximum
                    extent permitted by applicable law, Abbott hereby disclaims
                    all representations and warranties relating to the
                    information and content on the Application, whether
                    expressed or implied, created by law, contract or otherwise,
                    including, without limitation, any warranties of
                    merchantability, fitness for a particular purpose, title or
                    non-infringement of third party rights.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.2
                    </span>{' '}
                    The information and content on the Application does not
                    constitute medical advice or guidance in connection with any
                    particular condition, and in no case do they exempt the
                    individualised treatment of the patient by the responsible
                    healthcare professional. Healthcare professionals should
                    research the subject matter or consult an appropriate
                    expert, before making decisions relating to treatment or
                    care of any patient.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.3
                    </span>{' '}
                    The healthcare professional users of the Application must
                    know that the relationship is impersonal and is based on the
                    confidence that the professional provides truthful and
                    accurate information. Abbott is not responsible for the
                    consequences that may arise from the fact that the
                    professional provides false or inaccurate information during
                    the process of registering the data. Likewise, the results
                    obtained through the use of the Application are estimates
                    and will depend on the information provided by the
                    professional who performs the consultation.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.4
                    </span>{' '}
                    The result obtained through the use of the Application is
                    for informational purposes only and in no case supposes nor
                    should it be considered a substitute for a professional
                    medical opinion issued by the doctor responsible for the
                    treatment, or the performance of the relevant diagnostic
                    tests by the corresponding health professionals in order to
                    determine, from said tests, an adequate treatment. The
                    advice and approval of the responsible and qualified health
                    professional should always be sought for any questions or
                    queries related to medical care or before taking any action
                    related to the care and maintenance of health. Any
                    application or use of the information, resources, or
                    recommendations derived from the use of the Application are
                    under the responsibility of the healthcare professional user
                    of the Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.5
                    </span>{' '}
                    The diagnosis or treatment of any health problem should not
                    be based exclusively on the information offered through the
                    Application. The information provided cannot be used as a
                    substitute for a consultation with a qualified health
                    professional. By using the Application, the user healthcare
                    professional assumes full responsibility and all kinds of
                    risks regarding the pertinent use of the information
                    obtained through said Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.6
                    </span>{' '}
                    To the maximum extent permitted by applicable law, Abbott
                    shall not be liable for the consequences, damages or actions
                    that may arise from the misuse of the diagnosis and
                    recommendations obtained and Abbott hereby disclaims all
                    liability for any loss or damage which may be suffered by
                    any person, whether suffered directly, indirectly,
                    immediately or consequentially, and whether arising in
                    contract, tort (including negligence) or otherwise which
                    arises out of, or in connection with use of the Application
                    or any treatment or care decisions made by the user, except
                    in the case of death or personal injury resulting from
                    Abbott’s negligence.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.7
                    </span>{' '}
                    Abbott is not responsible, and provides no warranty
                    whatsoever, for the accuracy, effectiveness, timeliness and
                    suitability of any information or content obtained from
                    third parties, including any hyperlinks to and from
                    third-party websites.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>Your Use</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      17.1
                    </span>{' '}
                    By using the Application, you agree:
                  </TypographyStyled>
                  <ol type="a">
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (a)
                        </span>{' '}
                        not to disrupt, amend or intercept information posted on
                        the Application;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (b)
                        </span>{' '}
                        not to attempt to circumvent any security features of
                        the Application; and
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (c)
                        </span>{' '}
                        to abide by all applicable, national and international
                        laws, rules and regulations.
                      </TypographyStyled>
                    </li>
                  </ol>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      16.2
                    </span>{' '}
                    You must:
                  </TypographyStyled>
                  <ol type="a">
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (a)
                        </span>{' '}
                        not use the Application in any unlawful manner, for any
                        unlawful purpose, or in any manner inconsistent with
                        these Terms and Conditions, or act fraudulently or
                        maliciously, for example, by hacking into or inserting
                        malicious code, such as viruses, or harmful data, into
                        the App or any operating system;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (b)
                        </span>{' '}
                        not infringe our intellectual property rights or those
                        of any third party in relation to your use of the
                        Application (to the extent that such use is not licensed
                        by these Terms and Conditions); (c) not transmit any
                        material that is defamatory, offensive or otherwise
                        objectionable in relation to your use of the
                        Application; and
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (c)
                        </span>{' '}
                        not use the Application in a way that could damage,
                        disable, overburden, impair or compromise our systems or
                        security or interfere with other users.
                      </TypographyStyled>
                    </li>
                  </ol>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>Availability</TypographyTitleStyled>
              </li>
              <TypographyStyled>
                Abbott will use reasonable efforts to make the Application
                available 24 hours a day, 7 days a week. However, Abbott cannot
                guarantee this and takes no responsibility for any loss or
                damage that occurs due to an interruption of access to the
                Application. Abbott may interrupt the Application for
                maintenance reasons and will endeavour to provide reasonable
                notice of any planned events.
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Intellectual Property
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      19.1
                    </span>{' '}
                    The information, content and graphics published on the
                    Application (the “
                    <span style={{ fontFamily: 'CalibriBold' }}>
                      Information
                    </span>
                    ”) are owned by, or licensed to, Abbott. Permission to use
                    the Information is granted, provided that: (i) the above
                    copyright acknowledgement appears on all copies; (ii) use of
                    the Information is for informational, non-commercial
                    healthcare or personal use only; (iii) the Information is
                    not modified in any way; and (iv) no graphics available from
                    the Application are used separate from the accompanying
                    text. For all other uses of the Information or any Abbott
                    trademark, trade names or trade dress Abbott’s prior written
                    authorisation is required. Users are required that they are
                    strictly prohibited from reproducing the Application and/or
                    Estimation of Requirements Tool in all forms whatsoever.
                    Except as permitted above, no licence or right, express or
                    implied, is granted to any person under any patent,
                    trademark or other proprietary right of Abbott.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      19.2
                    </span>{' '}
                    Portions of the Application may include material provided by
                    third parties, in which intellectual property rights subsist
                    (“
                    <span style={{ fontFamily: 'CalibriBold' }}>
                      Third Party Materials
                    </span>
                    ”). The licensors of such Third Party Materials retain all
                    of their respective right, title, and interest in and to
                    such Third Party Materials. The Application may include or
                    incorporate third party software components that are
                    generally available free of charge under licenses granting
                    recipients broad rights to copy, modify, and distribute such
                    components (“
                    <span style={{ fontFamily: 'CalibriBold' }}>
                      Open Source Components
                    </span>
                    ”). Although the Application is provided to you subject to
                    these Terms and Conditions, nothing in these Terms and
                    Conditions will be deemed to prevent, restrict, or otherwise
                    prevent or restrict you from separately obtaining and using
                    such Open Source Components under the applicable third party
                    licenses or to limit your use of such Open Source Components
                    thereunder.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Privacy and Security
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      20.1
                    </span>{' '}
                    Abbott is committed to safeguarding your privacy. Abbott
                    does not collect any person information when the Application
                    is stored. Information relating to usage of the Application
                    is available to Abbott on an anonymised basis.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      20.2
                    </span>{' '}
                    It is your responsibility to ensure that the device used to
                    access the Application, is adequately secured and protected
                    against malicious software or access by unauthorised
                    persons. To the maximum extent permitted by applicable law,
                    Abbott shall not be liable for any direct, indirect,
                    special, incidental, or consequential damages (including
                    lost profits, whether arising directly or indirectly)
                    suffered by any person as a result of interception or
                    unauthorised access to their personal data, even if Abbott
                    has previously been advised of the possibility of such
                    damages.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      20.3
                    </span>{' '}
                    While Abbott does not need any location information due to
                    technical constraints the Adobe Analytics solution embedded
                    in the Abbot Nutritional App automatically collects location
                    data at a city level.
                  </TypographyStyled>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Limitation of Liability
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      21.1
                    </span>{' '}
                    Abbott does not assume any liability for the materials,
                    information and opinions provided on, posted to, or
                    otherwise available through, this Application. Reliance on
                    these materials, information and opinions is solely at the
                    user’s own risk. Abbott disclaims any liability for injury
                    or damages resulting from the use of the Application, or the
                    content contained thereon to the fullest extent permitted by
                    applicable law.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      21.2
                    </span>{' '}
                    This Application, the site content, and the products and
                    services provided on or available through this Application
                    are provided on an “as is” and “as available” basis, with
                    all faults. In no event shall Abbott, or its subsidiaries,
                    affiliates, vendors, or their respective directors,
                    licensors, employees or agents (“
                    <span style={{ fontFamily: 'CalibriBold' }}>
                      Abbott Parties
                    </span>
                    ”) be liable for any damages of any kind, under any legal
                    theory, arising out of or in connection with your use of, or
                    inability to use, the Application, the Application content,
                    any services provided on or through this Application or any
                    linked website, including any special, indirect, punitive,
                    incidental, exemplary or consequential damages. Except in
                    the case of death or personal injury caused by their
                    negligence, Abbott and the Abbott Parties hereby disclaim,
                    to the maximum extent permitted by applicable law, liability
                    for any loss or damage which may be suffered by any person,
                    whether suffered directly, indirectly, immediately or
                    consequentially, and whether arising in contract, tort
                    (including negligence) or otherwise which arises out of, or
                    in connection with: (i) use of, or inability to use, the
                    Application; (ii) use of information or content on the
                    Application; (iii) any services provided on or through the
                    Application; and (iv) interception or unauthorized access to
                    personal information submitted to the Application,
                    including, without limitation, the following categories of
                    loss or damage, whether or not Abbott has been advised of
                    the possibility of such loss or damage:
                  </TypographyStyled>
                  <ol type="a">
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (a)
                        </span>{' '}
                        loss or corruption of data;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (b)
                        </span>{' '}
                        loss of profits;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (c)
                        </span>{' '}
                        loss of anticipated savings;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (d)
                        </span>{' '}
                        loss of business opportunity;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (e)
                        </span>{' '}
                        loss of goodwill;
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (f)
                        </span>{' '}
                        loss of reputation; and
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (g)
                        </span>{' '}
                        special damage.
                      </TypographyStyled>
                    </li>
                  </ol>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>
                  Terminating Access to the Application
                </TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      22.1
                    </span>{' '}
                    Abbott may end your rights to use the Application at any
                    time by contacting you if you have broken these Terms and
                    Conditions in a serious way. If what you have done can be
                    put right Abbott will give you a reasonable opportunity to
                    do so.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      22.2
                    </span>{' '}
                    If Abbott ends your rights to use the Application:
                  </TypographyStyled>
                  <ol type="a">
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (a)
                        </span>{' '}
                        You must stop all activities authorised by these Terms
                        and Conditions, including your use of the Application.
                      </TypographyStyled>
                    </li>
                    <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                      <TypographyStyled>
                        <span
                          style={{
                            fontFamily: 'CalibriBold',
                            color: '#004F71'
                          }}
                        >
                          (b)
                        </span>{' '}
                        You must delete or remove the Application from all
                        devices in your possession and immediately destroy all
                        copies of the Application which you have and confirm to
                        Abbott that you have done this.
                      </TypographyStyled>
                    </li>
                  </ol>
                </li>
              </ol>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>Governing Law</TypographyTitleStyled>
              </li>
              <TypographyStyled>
                These Terms and Conditions shall be governed by and construed in
                accordance with the laws of the Republic of Ireland. Any dispute
                arising under these Terms and Conditions and shall be subject to
                the exclusive jurisdiction of the courts of the Republic of
                Ireland.
              </TypographyStyled>
              <li style={{ fontFamily: 'CalibriBold', color: '#004F71' }}>
                <TypographyTitleStyled>General</TypographyTitleStyled>
              </li>
              <ol>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      24.1
                    </span>{' '}
                    You agree that these Terms and Conditions describe the
                    entire agreement between you and Abbott with respect to this
                    Application.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      24.2
                    </span>{' '}
                    Abbott reserves the right to update, amend or vary these
                    Terms and Conditions from time to time.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      24.3
                    </span>{' '}
                    Abbott may transfer its rights and obligations under these
                    Terms and Conditions to another organisation.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      24.4
                    </span>{' '}
                    You may only transfer your rights or your obligations under
                    these Terms and Conditions to another person if Abbott
                    agrees to this in writing.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      24.5
                    </span>{' '}
                    These Terms and Conditions are between you and Abbott. No
                    other person shall have any rights to enforce any of its
                    terms.
                  </TypographyStyled>
                </li>
                <li style={{ listStyle: 'none', marginBottom: '0.5rem' }}>
                  <TypographyStyled>
                    <span
                      style={{ fontFamily: 'CalibriBold', color: '#004F71' }}
                    >
                      24.6
                    </span>{' '}
                    Each of the paragraphs of these Terms and Conditions
                    operates separately. If any court or relevant authority
                    decides that any of them are unlawful, the remaining
                    paragraphs will remain in full force and effect.
                  </TypographyStyled>
                </li>
              </ol>
              <TypographyTitleStyled>
                February 2025 IE-N/A-2500004
              </TypographyTitleStyled>
            </ol>
          </Box>
        </Box>
      </BoxStyled>
      <Grid container spacing={2}>
        {controlPadData.map((item) => (
          <ControlPad
            key={item.altVal}
            imgSrc={item.imgSrc}
            altVal={item.altVal}
            toLink={item.toLink}
            showIcon={item.showIcon}
          />
        ))}
      </Grid>
    </>
  );
};
